import { AxiosError } from "axios";
import * as R from "../../../requests/x2y/requestCreators";
import { FlowioThunkCreator } from "../../types";
import * as AC from "../actionCreators";
import * as S from "../selectors";
import { X2yController } from "../types";

type MakeThunkCreatorParams = {
  controller: X2yController;
};

// Thunk creator types
type ThunkCreatorParams = { xId: number };

export type FetchThunkCreator = FlowioThunkCreator<ThunkCreatorParams>;
export type MakeFetchThunkCreator = (
  p: MakeThunkCreatorParams
) => FetchThunkCreator;

// ==== FACTORY ====
const createFetchThunk: MakeFetchThunkCreator = ({ controller }) => {
  const getIsFetching = S.createGetIsFetching(controller);
  const request = R[controller].get;

  return ({ xId }) =>
    (dispatch, getState) =>
      Promise.resolve().then(async () => {
        const isFetching = getIsFetching(getState(), [xId]);
        if (isFetching) return;

        const reqPayload = { controller, xId };
        dispatch(AC.getX2yRequest(reqPayload));

        try {
          const response = await request(xId);
          const recPayload = { controller, xId, ...response.data };
          dispatch(AC.getX2yReceive(recPayload));
        } catch (error) {
          const errPayload = {
            controller,
            xId,
            error: (error as AxiosError).response || error,
          };
          dispatch(AC.getX2yError(errPayload));
        }
      });
};

export default createFetchThunk;
